import React from "react";
import { Container, Row, Col } from "shards-react";
import SAPP from "../components/invoicing/Invoices";
import SAPProject from "../components/sap-projects/Project";

const SAPProjectView = props => {
  const { id } = props.match.params;

  return (
    <Container fluid className="main-content-container px-4">
      <Row>
        <Col className="p-2">
          <SAPProject id={id} />
        </Col>
      </Row>
    </Container>
  );
};

export default SAPProjectView;
